import { schema } from 'normalizr';
import { clientSchema } from './clients';

export const wordlistSchema = new schema.Entity('wordlists', {
  client: clientSchema
});

export const wordlistItemSchema = new schema.Entity('wordlistItems', {
  wordlist: wordlistSchema
});